import React, {useEffect, useState} from 'react';
import {Props} from './interfaces';
import './HeaderMobPopup.scss';

import {connect, WithStore, MapStateToProps, MapDispatchToProps} from '../../../redux/services/Imports';
import {EnumUrlsPages} from '../../../services/Enum';
import Button from '../../Button/Button';
import {LinkDzen, LinkTg, LinkVk, LinkYoutube, SelectValuesFormSimple} from '../../../services/content/Constants';
import LinkLive from '../../LinkLive/LinkLive';
import MenuHamburgerStub from '../MenuHamburger/MenuHamburgerStub';
import DropdownList from '../DropdownList/DropdownList';
import ModalFormFeedback from '../../ModalFormFeedback/ModalFormFeedback';
import {createPortal} from 'react-dom';
import {content} from "../../../services/content";
import {Link} from "../../Link/Link";

const HeaderMobPopup = ({closed, show, widthWindow, menu}: Props) => {
  const [showFeedback, setShowFeedback] = useState(false);
  const openFeedback = () => setShowFeedback(true);
  const closedFeedback = () => setShowFeedback(false);

  const [showModalPartner, setShowModalPartner] = useState(false);
  const openModal = () => setShowModalPartner(true);
  const closedModal = () => setShowModalPartner(false);

  // contactForms из Redux приходит дефолтом со всеми id = 0. Реальные id формы лежат
  // в data-props серверной кнопки #header-button-feedback — читаем их сами, как это
  // делает десктопный Header. Иначе мобильная отправка падает с contactFormId: 0.
  const [contactForms, setContactForms] = useState({});
  useEffect(() => {
    const btn = document.getElementById('header-button-feedback');
    const props = btn?.dataset?.props ? JSON.parse(btn?.dataset?.props as string) : {contactForms: {}};
    setContactForms(props.contactForms);
  }, []);

  // Helper to safely check if children array has items
  const hasChildren = (obj: any) => {
    if (!obj || !obj.children) return false;
    if (!Array.isArray(obj.children)) return false;
    if (obj.children.length === 0) return false;
    return obj.children.flat().length > 0;
  };

  console.log('HeaderMobPopup menu:', {
    services: menu.services ? {
      hasTitle: !!menu.services.title,
      hasChildren: hasChildren(menu.services),
      children: menu.services.children
    } : null,
    geography: menu.geography ? {
      hasTitle: !!menu.geography.title,
      hasChildren: hasChildren(menu.geography),
      children: menu.geography.children
    } : null,
    contacts: menu.contacts ? {
      hasTitle: !!menu.contacts.title,
      hasChildren: hasChildren(menu.contacts),
      hasUrl: !!menu.contacts.url,
      children: menu.contacts.children
    } : null,
    lk: menu.lk ? {
      hasTitle: !!menu.lk.title,
      hasChildren: hasChildren(menu.lk),
      children: menu.lk.children
    } : null
  });

  return (
    <div className={`popup-header${show ? ' popup-header_open' : ' popup-header_hide'}`}>
      <div className="popup-header__header">
        <Link to="/" onClick={closed} className="popup-header__logo-link">
          <img src={require('./img/logo.svg').default} className="popup-header__logo" alt="logo"/>
        </Link>
        <MenuHamburgerStub onClick={closed}/>
      </div>

      <div className="popup-header__content">
        {menu.items ? (
          // Пункты по порядку из админки (см. MenuFixed); слоты ниже — для старых данных
          <div className="popup-header__list">
            {menu.items.map((item, i) =>
              item.kind !== 'link' && hasChildren(item) ? (
                <DropdownList title={item.title} list={item.children} closed={closed} key={i}/>
              ) : (
                <Link to={item.url} onClick={closed} key={i}>
                  <h4 className={item.mark ? 'link-live' : ''}>{item.title}</h4>
                </Link>
              )
            )}
          </div>
        ) : (
        <div className="popup-header__list">
          {menu.services && hasChildren(menu.services) &&
              <DropdownList
                title={menu.services.title}
                list={menu.services.children}
                closed={closed}
              />}

          {menu.calculator &&
              <Link to={menu.calculator.url} onClick={closed}>
                  <h4>{menu.calculator.title}</h4>
              </Link>}

          {menu.geography && hasChildren(menu.geography) &&
              <DropdownList title={menu.geography.title} list={menu.geography.children} closed={closed}/>}

          <LinkLive onClick={closed}/>

          {menu.contacts && hasChildren(menu.contacts) ? (
              <DropdownList title={menu.contacts.title} list={menu.contacts.children} closed={closed}/>
          ) : menu.contacts && menu.contacts.url ? (
              <Link to={menu.contacts.url} onClick={closed}>
                  <h4>{menu.contacts.title}</h4>
              </Link>
          ) : null}
        </div>
        )}

        <div className="popup-header__buttons">
          <Button
            text={content.header.textTracking}
            link={EnumUrlsPages.tracking}
            onClick={closed}
            type="border"
            size="S"
            widthAll
          />
          <Button text={content.header.textModalFeedback} onClick={openFeedback} size="S" widthAll/>
        </div>

        <div className="popup-header__list popup-header__list_m0">
          <div className="phone-link">
            <a className={'mgo_num_msk'} href={`tel:${content.header.textCity1Number}`}>
              <h4>{content.header.textCity1Number}</h4>
            </a>
            <p>{content.header.textCity1}</p>
          </div>
          <div className="phone-link">
            <a className={'mgo_num_spb'} href={`tel:${content.header.textCity2Number}`}>
              <h4>{content.header.textCity2Number}</h4>
            </a>
            <p>{content.footer.city2}</p>
          </div>
          <p>{content.header.textWorkSchedule}</p>
          {menu.lk && hasChildren(menu.lk) &&
              <DropdownList title={menu.lk.title} list={menu.lk.children} closed={closed}/>}
        </div>

        <div className="popup-header__socs">
          <a href={LinkTg} target="_blank" rel="nofollow">
            <img src={require('./img/tg.svg').default} alt=""/>
          </a>
          <a href={LinkDzen} target="_blank" rel="nofollow">
            <img src={require('./img/dzen.svg').default} alt=""/>
          </a>
          <a href={LinkVk} target="_blank" rel="nofollow">
            <img src={require('./img/vk.svg').default} alt=""/>
          </a>
          <a href={LinkYoutube} target="_blank" rel="nofollow">
            <img src={require('./img/youtube.svg').default} alt=""/>
          </a>
        </div>
      </div>

      {createPortal(
        <ModalFormFeedback
          hasCssTransition
          showForm={showFeedback}
          id="feedback"
          title={content.header.textModalFeedback}
          select={{options: SelectValuesFormSimple}}
          closedModal={closedFeedback}
          contactForms={contactForms}
        />,
        document.body
      )}

      {createPortal(
        <ModalFormFeedback
          hasCssTransition
          showForm={showModalPartner}
          id="partner"
          title={content.header.textBecomePartner}
          select={{
            options: [],
            disabled: true,
            active: SelectValuesFormSimple.find((x) => x.eventMetrika === 'form_partner'),
          }}
          closedModal={closedModal}
          eventMetrika="form_partner"
          sendAmoCRM
          contactForms={contactForms}
        />,
        document.body
      )}
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(HeaderMobPopup));
